import { useAppSelector, usePropertyTaxQuery } from "../../Hooks";
import { getOwnerId } from "../../common/utilities/roleHelpers";
import { IAccordionData } from "../../common/interfaces/accordionData";
import { AccordionView } from "../../common/accordion/accordion.view";
import { Col, Row } from "react-bootstrap";
import { PropertyTaxDetails } from "./PropertyTaxDetails";
import { BootstrapSpinner } from "../../common/spinners/bootstrapSpinner";
import { useMunicipality } from "../../Contexts/MunicipalityKey";
import { usePropertyTaxConfig } from "../../common/config/configHooks";
import { toCurrency } from "../../common/utilities/parser";

const PropertyTaxPage = () => {
  const municipalKey = useMunicipality();

  const activeRole = useAppSelector(state => state.role.activeRole);
  const ownerId = getOwnerId(activeRole);

  const propertyTaxService = usePropertyTaxConfig();

  const { data: propertyTaxItems, isPending: isFetchingPropertyTaxItems } =
    usePropertyTaxQuery(municipalKey.name, ownerId);

  const createAccordionData = (): IAccordionData[] => {
    let accordionData: { title: string; content: JSX.Element }[] = [];

    if (propertyTaxItems) {
      propertyTaxItems.map((data) => {
        return accordionData.push({
          title: data.adresse ?? "",
          content: (
            <>
              {!data.harEiendomsskatt || !data.takstBekreftet ? (
                <div>
                  <p>
                    Kunne ikke finne vedtatt eiendomsskatt på denne eiendommen.<br />
                    Ta kontakt med oss hvis du har spørsmål.
                    {propertyTaxService?.propertyTaxUrl && (
                      <> Du finner <a
                        href={propertyTaxService.propertyTaxUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        kontaktinfo og mer om eiendomsskatt
                      </a> på vår nettside.</>
                    )}
                  </p>
                </div>
              ) : (
                <>
                  <h2>Vedtatt eiendomsskatt:</h2>
                  <p className="ingress" style={{ fontSize: '22px' }}>
                    Eiendomsskatt {data.arstall}:{" "}
                    {toCurrency(data.beregnetSkatt)}
                  </p>
                  <AccordionView
                    showNarrow={true}
                    hideBorder={true}
                    content={[
                      {
                        title: "Se beregning",
                        content: 
                            <PropertyTaxDetails
                              data={data}
                              showHeader={false}
                            />
                      },
                    ]}
                  />{" "}
                </>
              )}
            </>
          ),
        });
      });
    }

    return accordionData;
  };

  return (
    <>
      <div className="container propertytax-container">
        <Row>
          <Col xs={{ span: 12 }}>
            <section>
              <h1>Eiendomsskatt</h1>
              {propertyTaxService?.hideService ? (
                "Tjenesten er dessverre ikke tilgjengelig"
              ) : (
                <>
                  {propertyTaxService?.alertText &&
                    propertyTaxService?.alertText !== "" && (
                      <div className="infoBoxLanding">
                        <p>{propertyTaxService?.alertText}</p>
                      </div>
                    )}
                  <p>{propertyTaxService?.ingressText}</p>
                  <div>
                    {!isFetchingPropertyTaxItems ? (
                      propertyTaxItems ? (
                        propertyTaxItems.length >= 1 ? (
                          <AccordionView
                            hideBorder={true}
                            content={createAccordionData()}
                          />
                        ) : (
                          propertyTaxService?.notFoundText
                        )
                      ) : (
                        propertyTaxService?.notFoundText
                      )
                    ) : (
                      <BootstrapSpinner title="Henter din eiendomsskatt..." />
                    )}
                  </div>
                </>
              )}
            </section>
          </Col>
        </Row>
      </div>
    </>
  );
};
export default PropertyTaxPage;
